import { render, staticRenderFns } from "./biology.vue?vue&type=template&id=6dc10567&scoped=true"
import script from "./biology.vue?vue&type=script&lang=js"
export * from "./biology.vue?vue&type=script&lang=js"
import style0 from "./biology.vue?vue&type=style&index=0&id=6dc10567&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc10567",
  null
  
)

export default component.exports